import { render } from "./SVGFrame.vue?vue&type=template&id=1bf2c8bc"
import script from "./SVGFrame.vue?vue&type=script&lang=js"
export * from "./SVGFrame.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__